import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Spinner } from './components/Shell';
import { API_BASE_URL } from './lib/api';
import HomePage from './pages/HomePage';
import ResultsPage from './pages/ResultsPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailurePage from './pages/PaymentFailurePage';
import ReportsPage from './pages/ReportsPage';
import ContactPage, { PrivacyPage, TermsPage, MaintenancePage } from './pages/StaticPages';

export default function App() {
  const [cfg, setCfg] = useState({ loading: true, maintenance: false, msg: '' });

  useEffect(() => {
    fetch(`${API_BASE_URL}/public-config`)
      .then((r) => r.json())
      .then((j) => setCfg({ loading: false, maintenance: !!j?.maintenance, msg: j?.maintenance_message || '' }))
      .catch(() => setCfg({ loading: false, maintenance: false, msg: '' }));
  }, []);

  if (cfg.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (cfg.maintenance) return <MaintenancePage message={cfg.msg} />;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/payment-failure" element={<PaymentFailurePage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </BrowserRouter>
  );
}
